import { render } from "./questioneditorgfig.vue?vue&type=template&id=2db76b0a&scoped=true"
import script from "./questioneditorgfig.vue?vue&type=script&lang=js"
export * from "./questioneditorgfig.vue?vue&type=script&lang=js"

import "./questioneditorgfig.vue?vue&type=style&index=0&id=2db76b0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db76b0a"]])

export default __exports__